import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import moment from 'moment';
import { dateTimeTemplate } from '../utils/mics';

const RenderTooltipTemplate = ({ rowData, field, header, columnType = 'String' }) => {

    let navigate = useNavigate();

    let value = rowData[field];

    const [className, setClassName] = useState('');

    // Conditionally add the 'text-danger' class
    useEffect(() => {
        // Check if pjoxmlStatus is not "Y" and createdOn + 20 minutes has passed
        const createdOn = moment( dateTimeTemplate(rowData?.createdOn), 'DD-MM-YYYY HH:mm:ss', true);
        const currentTime = moment();
        const timeDifference = currentTime.diff(createdOn, 'minutes');

        if (rowData?.pjoxmlStatus && rowData.pjoxmlStatus !== 'Y' && timeDifference > 20) {
            setClassName('text-danger');
        } else if(rowData?.status?.toLowerCase() === 'error'){
            setClassName('text-danger');
        }else{
            setClassName('');
        }
    }, [rowData]);

    // Convert JSON object to string if value is an object
    if (value && typeof value === 'object') {
        value = JSON.stringify(value, null, 2); // Pretty print with 2-space indentation
    }

    if (value && columnType === 'datetime') { 
        value = dateTimeTemplate(value);
    }

    // Function to handle click and show dialog for FileId column
    const handleFileIdClick = () => {
        if (header === 'FileId') {
            navigate('/ui/integration-file-log', { state: { filterByFileId: rowData[field] } });
        }
    };

    return (
        <div className={`td-tp-wrapper ${className}`}>
            {header === 'FileId' ? (
                <span  onClick={handleFileIdClick} className="clickable tp" data-pr-tooltip= {value}>
                    {value}
                </span>
            ) : (
                <span  className='tp' data-pr-tooltip= {value}>{value}</span>
            )}
        </div>
    );
};

export default RenderTooltipTemplate;